import React, { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router'
import Modal from '../Modal/Modal'
import { useGetLinkedAccounts } from '../../api/agencies/useGetLinkedAccounts'
import dayjs from 'dayjs'
import { getImageURL } from '../../lib/utils/getImageURL'
import { Link } from 'react-router-dom'
import { ReactComponent as ActionClose } from '../../images/icons/icon_close.svg'

export default function EditVendorAccount(): JSX.Element {
  const { account_id } = useParams()
  const navigate = useNavigate()
  const { data: vendors } = useGetLinkedAccounts()

  const vendorInfo = useMemo(
    () => vendors?.find((v) => v.id === Number(account_id)),
    [vendors, account_id],
  )

  return (
    <Modal key="EditVendorAccount" isOpen modalRoute>
      <div className="flex flex-col h-full w-full py-10 gap-5">
        <div className="flex flex-row justify-between border-b-2 w-full px-10">
          <h1 className="font-bold text-xl  mb-5">
            Edit Your {vendorInfo?.name} Connection
          </h1>
          <ActionClose
            className="stroke-primary-xiketic cursor-pointer"
            onClick={(e) => {
              e.preventDefault()
              navigate('../')
            }}
          />
        </div>
        <div className="flex flex-col gap-3 my-auto justify-center items-center w-full border-b-2">
          <div className="flex flex-row justify-between p-5 px-10 gap-5 w-full">
            <div className="flex flex-row gap-5">
              <div className="flex justify-center items-center">
                {vendorInfo?.logo ? (
                  <img
                    src={getImageURL(`images/vendors/${vendorInfo.logo}`)}
                    className="h-10 w-10 object-contain"
                  />
                ) : (
                  <></>
                )}
              </div>
              <div className="flex flex-col gap-2 items-start justify-center">
                <span className="font-bold text-lg">{vendorInfo?.name} Account</span>
                <span>
                  Connected as{' '}
                  <span className="font-bold">
                    {vendorInfo?.connectionDetails?.user_name}
                  </span>{' '}
                  on{' '}
                  {dayjs(vendorInfo?.connectionDetails?.created_date).format(
                    'MM/DD/YYYY',
                  )}
                </span>
              </div>
            </div>
            <div className="flex items-center">
              <Link
                to={`../${account_id}/delete`}
                className="text-secondary-engineering-red/80 font-bold text-sm">
                Delete Your Account
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
